import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";

function MenuPacientes() {

    const [permisos, setPermisos] = useState([]);
    const [client, setClient] = useState([]); // 🔧 Agregar estado para client
    const [loggedIn, setLoggedIn] = useState(false); // 🔧 Agregar estado para loggedIn
    let userdata = [];

    useEffect(()=>{

        if (!localStorage.getItem('userdata')) {
            setLoggedIn(true);
            return;
        }

        userdata = JSON.parse(localStorage.getItem('userdata'));
        
        // 🔒 VALIDACIÓN DE PERMISOS - Patrón híbrido (nuevo + legacy)
        let permisosList = [];
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            permisosList = userdata.permissions.map(p => p.slug);
        } else if (userdata.up) {
            permisosList = userdata.up;
        }
        
        setPermisos(permisosList);

        // ✅ Sin config manual - el interceptor agrega el token automáticamente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status===200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
                setLoggedIn(true); // Permitir continuar aunque falle la carga del cliente
            });

    },[]);

    if (loggedIn) {
        return (
            <div className="wrapper hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="patients" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left mb-0">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item active">Clientes</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2 align-items-end">
                                <div className="col-md-8">
                                    <div className="dash-wrap">
                                        <h1 className="dash-title">Clientes</h1>
                                        <p className="dash-subtitle mb-0">Accesos rápidos a pacientes y empresas</p>
                                    </div>
                                </div>
                                <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                    <Link to="/home" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                        <i className="fas fa-arrow-left mr-1"></i> Volver al inicio
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="dash-card mb-4">
                                <div className="dash-card-header">
                                    <h2 className="dash-card-title">
                                        <span className="title-icon" aria-hidden="true"><i className="fas fa-users"></i></span>
                                        Opciones
                                    </h2>
                                </div>
                                <div className="dash-card-body">
                                    <div className="quick-grid">
                                        <Link to="/pacientes" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-search"></i></div>
                                            <p className="quick-title">Buscar paciente</p>
                                            <p className="quick-sub">Consultar y filtrar historias</p>
                                        </Link>

                                        {permisos.includes('crearPacientes') && (
                                            <Link to="/crear-paciente" className="quick-card">
                                                <div className="quick-ico"><i className="fas fa-user-plus"></i></div>
                                                <p className="quick-title">Nuevo paciente</p>
                                                <p className="quick-sub">Registrar persona natural</p>
                                            </Link>
                                        )}

                                        {permisos.includes('crearPacientes') && (
                                            <Link to="/crear-empresa" className="quick-card">
                                                <div className="quick-ico"><i className="fas fa-building"></i></div>
                                                <p className="quick-title">Nueva empresa</p>
                                                <p className="quick-sub">Cliente jurídico o convenio</p>
                                            </Link>
                                        )}

                                        {permisos.includes('crearPacientes') && (
                                            <Link to="/listar-empresas" className="quick-card">
                                                <div className="quick-ico"><i className="fas fa-list"></i></div>
                                                <p className="quick-title">Listar empresas</p>
                                                <p className="quick-sub">Empresas y convenios</p>
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return (
        <Loading />
    );
}
export default MenuPacientes;